"use client";

import React, { useState, useEffect } from "react";
import "./Popup.css";
import logoPopup from "../../assets/images/logo-popup.png";
import { RedirectWhatsapp } from "../whatsapp/whatsapp";

const Popup: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(true);
  }, []);

  if (!isOpen) return null;

  return (
    <div className="popupOverlay">
      <div className="popup">
        <div className="popupLogo">
          <img src={logoPopup} alt="Banner Responsivo" className="logoPopup" />
        </div>
        <div className="popupConteudo">
          <div className="popupClose">
            <h2>Atenção Clientes</h2>
            <button onClick={() => setIsOpen(false)}>
              <strong>X</strong>
            </button>
          </div>
          <p>Devido ao grande volume de clientes, estamos disponibilizando um novo número para atendê-lo com mais rapidez e eficiência.</p>

          <p>
            <RedirectWhatsapp number="(11) 3116-3663" />
          </p>
          <p>Estamos à disposição para ajudar!</p>

          <p>
          Obrigado pela compreensão.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Popup;
